/**
 * 出力画面の AUTO_RT ペイロード（条件行・basicData・書式 ID・書式データ・相手書式）の最新 1 件。
 *
 * - ①が解決したとき、DL バナーの選定をやり直させるために同じペイロードで AUTO_RT を再 emit する
 * - RT1.0 ダイアログと②は書式データを受け取らないので、先行フェッチと同じ画面上の値をここから使う
 *   （保存値を読むと指紋がずれて①が余分に飛び、②の照合先が上書きされる）
 *
 * 送客が確定して FormatEdit が条件行を消したときは、同じ規則でここの条件行も消す。
 * 消さないと、①の解決時の再 emit が送客前の条件で他社の DL バナーを復活させる。
 */
import { emitter, UPDATE_RT_CONDITION } from '@/plugins/emitter'
import { getAutoRtSession } from '@/composables/useAutoRtSession'
import {
  buildShouldDisableRow,
  removeDisabledRtConditionRows
} from '@/utils/rtConditionDisable'

type UnknownRecord = Record<string, any>

export type CcAutoRtArgs = [unknown, UnknownRecord, string, unknown, unknown]

let latest: CcAutoRtArgs | null = null
let subscribed = false

function onUpdateRtCondition(payload: unknown) {
  if (!latest || !Array.isArray(payload)) return
  const [clientId, permissionType, isSended] = payload
  // 未送信 close は FormatEdit も行を消さない（request_able=false だけ。行オブジェクトは共有）
  if (typeof isSended === 'boolean' && !isSended) return
  const conditions = latest[0]
  if (!conditions || typeof conditions !== 'object') return
  const shouldRemove = buildShouldDisableRow(
    clientId,
    permissionType,
    getAutoRtSession().getRelatedAutoRtInfo(),
    conditions as any
  )
  latest = [
    removeDisabledRtConditionRows(conditions as any, shouldRemove),
    latest[1],
    latest[2],
    latest[3],
    latest[4]
  ]
}

export function rememberCcAutoRtArgs(args: unknown): void {
  if (!Array.isArray(args) || args.length !== 5) return
  latest = [
    args[0],
    (args[1] || {}) as UnknownRecord,
    String(args[2] || ''),
    args[3],
    args[4]
  ]
  if (!subscribed) {
    subscribed = true
    emitter.on(UPDATE_RT_CONDITION, onUpdateRtCondition)
  }
}

export function getCcAutoRtArgs(): CcAutoRtArgs | null {
  return latest
}

/** output 離脱時（FORCE_HIDE_RT_DIALOGS）に捨てる。別画面で古い書式データを使わないため */
export function clearCcAutoRtArgs(): void {
  latest = null
}
